import React, { useCallback } from 'react';

import {
  ITEM_TYPE_FEE,
  ITEM_TYPE_PRODUCT,
  ITEM_TYPE_TEXT,
} from '@/common/constants';
import Fee from '@/ebat/components/blocks/Scanbat/CheckoutConfirm/OrderItem/Fee/Fee';
import Product from '@/ebat/components/blocks/Scanbat/CheckoutConfirm/OrderItem/Product/Product';
import Text from '@/ebat/components/blocks/Scanbat/CheckoutConfirm/OrderItem/Text/Text';

const useContent = () => {
  const getItemType = useCallback((item) => {
    switch (item.type.toLowerCase()) {
      case ITEM_TYPE_PRODUCT:
        return (
          <Product
            deliverableQuantity={item.deliverable_quantity}
            deliveredQuantity={item.delivered_quantity}
            deliveredQuantityLabel={item.delivered_quantity_label}
            priceTTC={
              item.product?.price_and_stock?.price?.discount_price_incl_vat ||
              item.product?.price_and_stock?.price?.public_price_incl_vat
            }
            id={item.id}
            label={item.product?.name || item.label}
            orderedQuantity={item.ordered_quantity}
            productBrand={item.product_brand}
            productId={item.product_id}
            productPrice={item.price}
            returnedQuantity={item.returned_quantity}
            saleUnit={item.sale_unit}
            salesPackaging={item.product?.price_and_stock?.sales_packaging}
            shippingDelay={item.shipping_delay}
            splitPackaging={item.product?.price_and_stock?.split_packaging}
            supplierReference={item.supplier_reference}
            totalLineAmount={item.total_line_amount}
            totalLineAmountTTC={
              (item.product?.price_and_stock?.price?.discount_price_incl_vat ||
                item.product?.price_and_stock?.price?.public_price_incl_vat) *
              item.ordered_quantity
            }
            weeeTaxAmount={item.weee_tax_amount}
            weeeTotalTaxAmount={item.weee_total_tax_amount}
          />
        );
      case ITEM_TYPE_FEE:
        return (
          <Fee label={item.product?.name || item.label} price={item.price} />
        );
      case ITEM_TYPE_TEXT:
      default:
        return <Text label={item.product?.name || item.label} />;
    }
  }, []);

  return {
    getItemType,
  };
};

export default useContent;
